<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
          placeholder="公司名"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false,multiple: true }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userIds"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID/ICCIDS空格隔开"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="imsi">
        <el-input v-model="queryParams.imsi" placeholder="IMSI/IMSI空格隔开"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="distribution" >
          <el-select v-model="queryParams.distribution" filterable placeholder="是否分配" @change="search" clearable>
            <el-option
              v-for="item in assignData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      <el-form-item prop="eid">
        <el-input v-model="queryParams.eid" placeholder="请输入EID"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="state">
        <el-select v-model="queryParams.state" filterable placeholder="状态" @change="search" clearable multiple >
          <el-option value="Released" label="Released"></el-option>
          <el-option value="Enable" label="Enable"></el-option>
          <el-option value="Delete" label="Delete"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" @click="handleExport" icon="el-icon-download"  v-hasPermi="['card:export']">导出</el-button>
      </el-form-item>
    </el-form>
      <el-table 
        :data="tableData" 
        border
        id="out-table"
        ref="tableData"
        v-loading="loading"
      >
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="company" label="代理商" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" :sortable="adminShow ? 'custom' : false" width="200px">
        <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="info(scope.row)">{{ scope.row.iccid }}</el-link>
            <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                <i style="font-size:16px;margin-left:2px" class="el-icon-document-copy" @click="copy(scope.row.iccid)"></i>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="eid" label="EID" align="center" width="300px"></el-table-column>
      <el-table-column prop="smdpAddress" label="SM-DP+地址" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="installDevice" label="安装设备" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="installCount" label="安装次数" align="center" width="100px"></el-table-column>
      <el-table-column prop="installTime" label="安装时间" align="center" width="200px" ></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center" width="200px" ></el-table-column>
      <el-table-column prop="downloadUrl" label="Download URL" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="state" label="状态" align="center" v-if="adminShow">
        <template slot-scope="{row}">
          <el-tag v-if="row.state =='Enable'">Enable</el-tag>
          <el-tag v-else-if="row.state =='Released'" type="info">Released</el-tag>
          <el-tag v-else-if="row.state =='Delete'" type="error">Delete</el-tag>
          <el-tag v-else type="warning">未知</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary" plain
              icon="el-icon-view"
              @click="handleEsimQrcode(scope.row)"
              v-hasPermi="['card:esim:qrcode']"
            >二维码</el-button>
          <el-button
            size="mini"
            type="primary" plain
            icon="el-icon-refresh"
            @click="refresh(scope.row)"
            v-hasPermi="['card:esim:refresh']"
          >刷新</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />

    <el-dialog title="扫码加载配置" :visible.sync="showQrCode" :lock-scroll="false" width="500px" v-dialogDrag center>
      <div class="qrcode-image">
        <div class="block">
          <el-image :src="scanQrCode"></el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import { cardEsimPage , eSIMQrCode , eSIMRefresh , exportEsim} from "@/api/esim.js";
import { agentTreeList } from "@/api/api.js"; //代理商
export default {
  name: "internationalCards",
  data() {
    return {
        total:0,
        page:1,
        pageSize:20,
        // 代理商
        agentTree: [],
        tableData:[],
        queryParams:{
            userId:undefined,
            iccid:undefined,
            imsi:undefined,
            distribution:undefined,
            state:undefined,
            userIds:[],
            eid:undefined
        },
        assignData:[
        {
          value: 0,
          label: "未分配"
        },
        {
          value: 1,
          label: "已分配"
        },
      ],
        showQrCode:false,
        scanQrCode:''
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    initData(){
      this.loading = true;
      let params = {
          model:{
              ... this.queryParams
          },
          page: this.page,
          pageSize: this.pageSize,
      };
      cardEsimPage(params).then(res => {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
      });
    },
    search() {
      this.page = 1,
      this.initData();
    },
    resetQuery() {
      this.resetForm("queryForm");
      this.$refs.myCascader.$refs.panel.clearCheckedNodes();
      this.$refs.myCascader.$refs.panel.activePath = [];
      this.search();
    },
    info(row) {
      this.$router.push({path:"/international/internationalDetail",query:{iccid: row.iccid}});
    },
    //复制数据
    copy(data) {
      let url = data;
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
          message: '复制成功',
          type: 'success',
          duration:1000
      });
      oInput.remove()
    },
    handleEsimQrcode(row){
      this.showQrCode = true
      let iccid = row.iccid
      eSIMQrCode({iccid}).then(res=>{
        this.scanQrCode = "data:image/jpeg;base64," + res.data.data;
      })
    },
    refresh(row){
      let iccid = row.iccid
      eSIMRefresh({iccid}).then(res=>{
        this.initData()
        this.$message.success("刷新成功");
      })
    },
    //导出图片
    handleExport(){
      let params = {
        ... this.queryParams
      }
      exportEsim(params).then(res=>{
        this.$message.success("导出成功");
      })

    }
  },
  created() {
    this.initData()
    this.handleAgentTreeList();
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
.qrcode-image{
  text-align: center;
  .el-image {
    width: 300px;
    height: 300px;
  }
}
</style>
